// extracted by mini-css-extract-plugin
module.exports = {"topicsContainer":"topics_topicsContainer__2Dqpg","box":"topics_box__32NB8"};